import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailDocumentModification } from '../dto/trail-document-modification';

@Injectable({
  providedIn: 'root'
})
export class TrailDocumentModificationService {

  private apiUrl = environment.apiRoot + '/trialdocumodification';

  constructor(private http: HttpClient) { }

  getAllSetupOfTrial(trialId: number): Observable<TrailDocumentModification[]> {
    return this.http.get<TrailDocumentModification[]>(this.apiUrl + '/alloftrial?trialId=' + trialId);
  }

  createDocumentModification(trialId: number): Observable<TrailDocumentModification> {
    let model = { "id": 0, "trial_id": trialId, "name": "new modification" };
    return this.http.post<TrailDocumentModification>(this.apiUrl + '/new', model);
  }

  updateDocumentModification(model: TrailDocumentModification): Observable<TrailDocumentModification> {
    return this.http.put<TrailDocumentModification>(this.apiUrl + '/update', model);
  }

  deleteDocumentModification(trialDocumentModificationId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialDocuModificationlId=' + trialDocumentModificationId);
  }
}
